import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FramePlaceholderBoundary } from './FramePlaceholderBoundary';
import { QuantityStepper } from '../ui/QuantityStepper';
import { usePrototype } from '../../contexts/PrototypeContext';
import { siteConfig } from '../../data/siteConfig';
import { formatPrice } from '../../utils/currency';
import { buttonClasses } from '../../utils/buttonStyles';

/**
 * VISUAL PLACEHOLDER — native Website Forge PRODUCT frame output.
 *
 * This is not a production add-to-cart. At integration, render the EXISTING native
 * product frame here and preserve its emitted HTML, actions, field names/IDs, hidden
 * inputs, SKU, quantity and option handling, and price. Native markup/IDs have not been
 * inspected; nothing here asserts compatibility. Prices and fulfillment copy reflect
 * the client's 14 October 2026 reply; native configuration still owns live transactions.
 */
export function WfProductFramePreview() {
  const [qty, setQty] = useState(1);
  const {
    quantity,
    setQuantity,
    campaignName
  } = usePrototype();
  const navigate = useNavigate();
  const {
    product,
    support,
    fulfillment
  } = siteConfig;
  const handleAdd = () => {
    setQuantity(quantity + qty);
    navigate('/cart');
  };
  return <FramePlaceholderBoundary frame="WfProductFramePreview" data-id="element-127" data-mp="3psvngcqqpfq7">
      <div className="flex flex-col" data-id="element-128" data-mp="3ur700v8f64c4">
        <p className="text-[14px] text-ink-muted" data-id="element-129" data-mp="2ltd1clh3wq7">{product.descriptor}</p>
        <h3 className="mt-2 font-display text-4xl font-medium leading-tight text-ink md:text-5xl" data-id="element-130" data-mp="2ljnfq4cbrl1">{product.name}</h3>
        <p className="mt-4 text-[13px] font-medium text-bronze-deep [overflow-wrap:anywhere]" data-id="element-131" data-mp="7ijt3zxa2sbm">{campaignName}</p>
        <div className="mt-1 flex flex-wrap items-baseline gap-3 tabular-nums" data-id="element-132" data-mp="haprpsi1c7zs">
          <p className="text-3xl text-ink" data-id="element-133" data-mp="hcskulehih8q">{formatPrice(product.samplePrice)}</p>
          <p className="text-[16px] text-ink-muted" data-id="element-134" data-mp="mbnao7avd62c"><span className="sr-only" data-id="element-135" data-mp="qb4hb4218993">Regular price </span><s data-id="element-136" data-mp="qbxfvhqu7sg5">{formatPrice(product.regularPrice)}</s></p>
          <p className="text-[14px] text-ink-muted" data-id="element-137" data-mp="2nbs5tr7cwd0b">Save {formatPrice(product.regularPrice - product.samplePrice)}</p>
        </div>
        <p className="mt-3 text-[14px] leading-relaxed text-ink-muted" data-id="element-138" data-mp="2ie082gk15wo7">{fulfillment.shippingLabel} · {fulfillment.dispatch}</p>

        <p className="mt-6 max-w-md text-[16px] leading-relaxed text-ink-muted" data-id="element-139" data-mp="2w5n4qhhvx77i">
          For men and women. Run the white silicone light-therapy mask by voice — just say “Hi Mask” — or use the included handheld controller.
        </p>

        <dl className="mt-8 border-t border-line" data-id="element-140" data-mp="313otnj1zs0qw">
          <div className="flex items-center justify-between gap-4 border-b border-line py-4" data-id="element-141" data-mp="3136r64oqkqaj">
            <dt className="text-[14px] text-ink-muted" data-id="element-142" data-mp="3f2oaw5n6ddd1">Color</dt>
            <dd className="flex items-center gap-3 text-[15px] font-medium text-ink" data-id="element-143" data-mp="3b1cr4gqzfmcr">
              <span aria-hidden="true" className="h-5 w-5 rounded-full border border-line-strong bg-surface" data-id="element-144" data-mp="1konavhfw2kbd" />
              {product.color}
            </dd>
          </div>
          <div className="flex items-center justify-between gap-4 border-b border-line py-3" data-id="element-145" data-mp="1gpxztvibpeuw">
            <dt id="product-qty-label" className="text-[14px] text-ink-muted" data-id="element-146" data-mp="16lrb4t1mkayd">
              Quantity
            </dt>
            <dd data-id="element-147" data-mp="wtv60y14fkkn">
              <QuantityStepper value={qty} onChange={setQty} label="Quantity" data-id="element-148" data-mp="wud4m1b9aavq" />
            </dd>
          </div>
        </dl>

        <button type="button" onClick={handleAdd} className={`${buttonClasses('primary', true)} mt-8`} data-id="element-149" data-mp="11rn5cd43i8yv">
          Add to bag
        </button>

        <p className="mt-5 text-[14px] text-ink-muted" data-id="element-150" data-mp="my0efdex6f5q">
          Questions before you order? Call{' '}
          <a href={support.phoneHref} className="font-medium text-ink underline underline-offset-4" data-id="element-151" data-mp="duza9i9m6y4p">
            {support.phone}
          </a>
          .
        </p>
      </div>
    </FramePlaceholderBoundary>;
}